import { Divider, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { fbaConversionFactors } from "./fbaConversionFactors";

const useStyles = makeStyles(theme => ({
  summaryContainer: {
    display: 'flex',
    margin: '0 20px',
    justifyContent: 'space-around'
  },
  summarySection: {
    display: 'flex',
    flexDirection: 'column',
    // marginRight: 60
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  summaryHeading: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: theme.palette.text.secondary
  },
  summaryText: {
    fontSize: '12px'
  },
  summaryValue: {
    paddingLeft: 10
  },
}));

export function FBAHistoryMatchSummary({ fba }) {
  
  const classes = useStyles();
  const globalUnits = fba?.settings?.units?.value;

  return (
    <div className={classes.summaryContainer}>
      <div className={classes.summarySection}>
        <Typography className={classes.summaryHeading}>FRACSEED SUMMARY</Typography>
        <Divider />
        <div className={classes.summaryRow}>
        <Typography className={classes.summaryText}>{`Frac Conductivity (${globalUnits === 'metric' ? 'md-m' :'md-ft'})`}</Typography>
          <Typography className={classes.summaryValue}>{!isNaN(fba?.rtaSummary?.fc) ? (globalUnits === 'metric' ? fba?.rtaSummary?.fc * fbaConversionFactors.fc : fba?.rtaSummary?.fc)?.toFixed(2) : ""}</Typography>
        </div>
        <Divider />
        <div className={classes.summaryRow}>
          <Typography className={classes.summaryText}>Frac Skin</Typography>
          <Typography className={classes.summaryValue}>{!isNaN(fba?.rtaSummary?.st) ? fba?.rtaSummary?.st?.toFixed(2) : ""}</Typography>
        </div>
        <Divider />
        <div className={classes.summaryRow}>
        <Typography className={classes.summaryText}>{`Fracture Area (${globalUnits === 'metric' ? 'm2' : 'Acres'})`}</Typography>
          <Typography className={classes.summaryValue}>{!isNaN(fba?.rtaSummary?.fractureArea) ? (globalUnits === 'metric' ? fba?.rtaSummary?.fractureArea * fbaConversionFactors.fractureArea: fba?.rtaSummary?.fractureArea)?.toFixed(2) : ""}</Typography>
        </div>
        <Divider />
      </div>
      <div className={classes.summarySection}>
        <Typography className={classes.summaryHeading}>HISTORY MATCH</Typography>
        <Divider />
        <div style={{display: 'flex'}}>
          <div style={{display: 'flex', flexDirection: 'column', marginRight: 40}}>
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>{`Frac Conductivity (${globalUnits === 'metric' ? 'md-m' :'md-ft'})`}</Typography>
              <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.fractureConductivityPreBT?.value) ? fba?.settings?.fractureConductivityPreBT?.value?.toFixed(2) : ""}</Typography>
              {/* <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.fractureConductivityPreBT?.value) ? (globalUnits === 'metric' ? fba?.settings?.fractureConductivityPreBT?.value * fbaConversionFactors.fractureConductivityPreBT : fba?.settings?.fractureConductivityPreBT?.value)?.toFixed(2) : ""}</Typography> */}
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>Matrix Permeability</Typography>
              <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.kMatrixInflow?.value) ? fba?.settings?.kMatrixInflow?.value : ""}</Typography>
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>Frac Skin</Typography>
              <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.skinPreBT?.value) ? fba?.settings?.skinPreBT?.value : ""}</Typography>
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>Matrix Skin</Typography>
              <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.skinMatrixInflow?.value) ? (fba?.settings?.skinMatrixInflow?.value * 1000)?.toFixed(4) : ""}</Typography>
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>Fracture Efficiency (%)</Typography>
              <Typography className={classes.summaryValue}>{!isNaN(fba?.historyMatchSummary?.fracEfficiency) ? (fba?.historyMatchSummary?.fracEfficiency * 100)?.toFixed(2) : ""}</Typography>
            </div>
            <Divider />
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div className={classes.summaryRow}>
            <Typography className={classes.summaryText}>{`Fracture Area BBT (${globalUnits === 'metric' ? 'm2' : 'Acres'})`}</Typography>
            <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.drainageAreaPreBT?.value) ? (fba?.settings?.drainageAreaPreBT?.value)?.toFixed(2) : ""}</Typography>
            {/* <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.drainageAreaPreBT?.value) ? (globalUnits === 'metric' ? fba?.settings?.drainageAreaPreBT?.value * fbaConversionFactors.fractureArea: fba?.settings?.drainageAreaPreBT?.value)?.toFixed(2) : ""}</Typography> */}
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>{`Fracture Area ABT (${globalUnits === 'metric' ? 'm2' : 'Acres'})`}</Typography>
              <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.drainageAreaPostBT?.value) ? (fba?.settings?.drainageAreaPostBT?.value)?.toFixed(2) : ""}</Typography>
              {/* <Typography className={classes.summaryValue}>{!isNaN(fba?.settings?.drainageAreaPostBT?.value) ? (globalUnits === 'metric' ? fba?.settings?.drainageAreaPostBT?.value * fbaConversionFactors.fractureArea: fba?.settings?.drainageAreaPostBT?.value)?.toFixed(2) : ""}</Typography> */}
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>{`Half Length BBT (${globalUnits === 'metric' ? 'm' : 'ft'})`}</Typography>
              <Typography className={classes.summaryValue}>{(!isNaN(fba?.historyMatchSummary?.totalXFBBT) && fba?.settings?.n_f?.value > 0) ? 
                (globalUnits === 'metric' ? (fba?.historyMatchSummary?.totalXFBBT / fba?.settings?.n_f?.value) * fbaConversionFactors.halfLength : (fba?.historyMatchSummary?.totalXFBBT / fba?.settings?.n_f?.value))?.toFixed(2) : ""}</Typography>
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>{`Half Length ABT (${globalUnits === 'metric' ? 'm' : 'ft'})`}</Typography>
              <Typography className={classes.summaryValue}>{(!isNaN(fba?.historyMatchSummary?.totalXFMatrixInflow) && fba?.settings?.n_f?.value > 0) ? 
                (globalUnits === 'metric' ? (fba?.historyMatchSummary?.totalXFMatrixInflow / fba?.settings?.n_f?.value) * fbaConversionFactors.halfLength : (fba?.historyMatchSummary?.totalXFMatrixInflow / fba?.settings?.n_f?.value))?.toFixed(2) : ""}</Typography>
            </div>
            <Divider />
            <div className={classes.summaryRow}>
              <Typography className={classes.summaryText}>Mobile Fluid Efficiency (%)</Typography>
              <Typography className={classes.summaryValue}>{!isNaN(fba?.historyMatchSummary?.fluidEfficiency) ? (fba?.historyMatchSummary?.fluidEfficiency * 100)?.toFixed(2) : ""}</Typography>
            </div>
            <Divider />
          </div>
        </div>
      </div>
    </div>
  );
};